import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = () => {
    const { isAuthenticated } = useAuth();

    return isAuthenticated ? (
        <Navigate to="/chat" />
    ) : (
        <Outlet />
    );
};

export default PublicRoute;
